import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Warehouse } from 'app/models/warehouse.models';
import { AlmacenService } from 'app/services/almacen.service';
import { AlmacenAddEditComponent } from '../almacen-add-edit/almacen-add-edit.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-almacenes-list',
  templateUrl: './almacenes-list.component.html',
  styleUrls: ['./almacenes-list.component.css'],
})
export class AlmacenesListComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  almacenes: Warehouse[] = [];
  dataSource: MatTableDataSource<Warehouse>;
  isLoading: boolean = false;
  displayedColumns: string[] = [
    'number',
    'name',
    'address',
    'phone',
    'email',
    'manager',
    'acciones',
  ];

  constructor(
    private dialog: MatDialog,
    private almacenService: AlmacenService,
    private snackBar: MatSnackBar
  ) {
    this.dataSource = new MatTableDataSource(this.almacenes);
  }

  ngOnInit() {
    this.getAlmacenes();
    const sidebar = <HTMLElement>document.querySelector('.navbar-brand');
    if (sidebar !== undefined) {
      sidebar.innerHTML = 'Almacenes y Depósitos';
    }
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  getAlmacenes() {
    this.isLoading = true;
    this.almacenes = [];
    this.almacenService.getAlmacenes().subscribe(
      (data: Warehouse[]) => {
        this.almacenes = data;
        this.dataSource = new MatTableDataSource(this.almacenes);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.isLoading = false;
        console.log({ alm: data });
      },
      error => {
        console.error('Error al obtener almacenes:', error);
        this.isLoading = false;
        this.showMessage('Error al cargar los almacenes', 'error');
      }
    );
  }

  editarAlmacen(almacen: Warehouse) {
    this.dialog
      .open(AlmacenAddEditComponent, {
        width: '40%',
        data: {
          warehouse: almacen,
          tipo: 'Editar',
        },
      })
      .afterClosed()
      .subscribe(result => {
        if (result) {
          this.getAlmacenes();
        }
      });
  }

  eliminarAlmacen(almacen: Warehouse) {
    if (confirm('¿Está seguro de eliminar este almacén?')) {
      this.almacenService.deleteAlmacen(almacen.id).subscribe(
        () => {
          this.showMessage('Almacén eliminado correctamente');
          this.getAlmacenes();
        },
        error => {
          console.error('Error al eliminar el almacén:', error);
          this.showMessage('Error al eliminar el almacén', 'error');
        }
      );
    }
  }

  abrirDialogo() {
    this.dialog
      .open(AlmacenAddEditComponent, {
        width: '40%',
        disableClose: true,
        data: {
          tipo: 'Agregar',
          warehouses: this.almacenes,
        },
      })
      .afterClosed()
      .subscribe(result => {
        if (result) {
          this.getAlmacenes();
        }
      });
  }

  aplicarFiltro(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  showMessage(message: string, type: 'success' | 'error' = 'success') {
    this.snackBar.open(message, 'Cerrar', {
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: type === 'error' ? ['error-snackbar'] : ['success-snackbar'],
    });
  }
}
